const tab_sections = {
    identity: 'هویت',
    integrations: 'اتصالات',
    login_security: 'ورود و امنیت',
    permissions: 'مجوزها',
    automation: 'خودکارسازی',
    platform: 'پلتفرم',
    overview: 'نمای کلی',
    authentication: 'احراز هویت',
    authorization: 'مجوزدهی',
    users: 'کاربران',
    developer: 'توسعه‌دهنده',
    tenant: 'مستأجر',
};
export default Object.freeze(tab_sections);
